var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('header-section'),_c('services-section'),_c('order-service'),_c('customers-section'),_c('our-clients')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }